import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    // Initialize the toggle state based on checkbox
    if (this.element.checked) {
      this.hide()
    }
  }

  toggle() {
    if (this.element.checked) {
      this.hide()
    } else {
      this.show()
    }
  }

  hide() {
    const targetId = this.targetValue
    const target = document.getElementById(targetId)
    if (target) {
      target.classList.add('d-none')
      // Remove required attribute from all required fields in the target
      this.toggleRequiredFields(target, false)
    }
  }

  show() {
    const targetId = this.targetValue
    const target = document.getElementById(targetId)
    if (target) {
      target.classList.remove('d-none')
      // Add required attribute back to all fields that should be required
      this.toggleRequiredFields(target, true)
    }
  }

  toggleRequiredFields(container, isRequired) {
    // Find all input fields in the container that have the required attribute or data-was-required attribute
    const requiredFields = container.querySelectorAll('input[required], input[data-was-required="true"]')
    
    requiredFields.forEach(field => {
      if (isRequired) {
        // If we're showing fields, add the required attribute back if it was previously required
        if (field.getAttribute('data-was-required') === 'true') {
          field.setAttribute('required', '')
          field.removeAttribute('data-was-required')
        }
      } else {
        // If we're hiding fields, store the required state and remove the required attribute
        if (field.hasAttribute('required')) {
          field.setAttribute('data-was-required', 'true')
          field.removeAttribute('required')
        }
      }
    })
  }
}
